import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "name", "email", "phone", "countryCode", "region", "city", "note", "fields"]
  static values = {
    buyers: Array
  }

  connect() {
    // Initialize state based on current selection
    this.buyerChanged()
  }

  buyerChanged() {
    const buyerId = this.selectTarget.value

    if (buyerId === "new") {
      this.clearFields()
      this.enableFields()
    } else if (buyerId) {
      const buyer = this.buyersValue.find(b => b.id === parseInt(buyerId))
      if (buyer) {
        this.populateFields(buyer)
        this.disableFields()
      }
    } else {
      this.clearFields()
      this.enableFields()
    }

    this.updateFieldsVisibility()
  }

  populateFields(buyer) {
    this.nameTarget.value = buyer.name || ""
    this.emailTarget.value = buyer.email || ""
    this.phoneTarget.value = buyer.phone || ""
    if (this.hasCountryCodeTarget) {
      this.countryCodeTarget.value = buyer.country_code || "UA"
      this.countryCodeTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
    this.regionTarget.value = buyer.region || ""
    this.cityTarget.value = buyer.city || ""
    if (this.hasNoteTarget) {
      this.noteTarget.value = buyer.note || ""
    }
  }

  clearFields() {
    this.nameTarget.value = ""
    this.emailTarget.value = ""
    this.phoneTarget.value = ""
    if (this.hasCountryCodeTarget) {
      this.countryCodeTarget.value = "UA"
      this.countryCodeTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
    this.regionTarget.value = ""
    this.cityTarget.value = ""
    if (this.hasNoteTarget) {
      this.noteTarget.value = ""
    }
  }

  enableFields() {
    this.nameTarget.disabled = false
    this.emailTarget.disabled = false
    this.phoneTarget.disabled = false
    if (this.hasCountryCodeTarget) {
      this.countryCodeTarget.disabled = false
    }
    this.regionTarget.disabled = false
    this.cityTarget.disabled = false
    if (this.hasNoteTarget) {
      this.noteTarget.disabled = false
    }
  }

  disableFields() {
    this.nameTarget.disabled = true
    this.emailTarget.disabled = true
    this.phoneTarget.disabled = true
    if (this.hasCountryCodeTarget) {
      this.countryCodeTarget.disabled = true
    }
    this.regionTarget.disabled = true
    this.cityTarget.disabled = true
    if (this.hasNoteTarget) {
      this.noteTarget.disabled = true
    }
  }

  updateFieldsVisibility() {
    const buyerId = this.selectTarget.value
    const showFields = buyerId === "new" || !buyerId

    if (this.hasFieldsTarget) {
      this.fieldsTarget.classList.toggle("hidden", !showFields && buyerId)
    }
  }
}
